import React, { useContext } from 'react';
import styled from 'styled-components';

import { PageContext } from '../components/page';
import { FlightStatus } from './FlightStatus';
import { BodyCard } from '../components/styledComponent';
import { FlightSummary, emptyFieldCharacter } from './FlightSummary';
import { Codeshares } from './Codeshares';
import { EventTimeline } from './EventTimeline';
import { ProcessedFlightHistory, CarrierDetails } from '../../types/flight';

export const iataOrFallBackToLabeledFS = (
  item?: CarrierDetails,
  naCharacter: string = emptyFieldCharacter,
): string => {
  return item?.iata || (item?.fs ? `${item.fs}:FS` : naCharacter);
};

const CenteredText = styled.div`
  text-align: center;
`;

interface FlightViewBodyProps {
  flightData?: ProcessedFlightHistory | null;
}

export const FlightViewBody: React.FC<FlightViewBodyProps> = ({ flightData }) => {
  const { query } = useContext(PageContext);
  const { flightNumber: queryFlightNumber, carrier } = query;

  const codeshareFlight = flightData?.codeshares?.find(
    (flight: any) =>
      flight.flightNumber === queryFlightNumber &&
      flight.carrierDetails?.iata === carrier,
  );

  const carrierSource =
    codeshareFlight?.carrierDetails?.iata || codeshareFlight?.carrierDetails?.fs
      ? codeshareFlight?.carrierDetails
      : flightData?.carrierDetails;
  const carrierName = ` ${carrierSource?.name || emptyFieldCharacter}`;

  const carrierDisplayName = `(${iataOrFallBackToLabeledFS(
    carrierSource,
  )})${carrierName}`;

  const flightNumber =
    codeshareFlight?.flightNumber || flightData?.flightNumber;

  const departureAirportDisplayCode = iataOrFallBackToLabeledFS(
    flightData?.departureDetails,
  );

  const arrivalAirportDisplayCode = iataOrFallBackToLabeledFS(
    flightData?.arrivalDetails,
  );

  const divertedAirportDisplayCode = iataOrFallBackToLabeledFS(
    flightData?.divertedDetails,
    '',
  );

  return (
    <>
      {flightData && (
        <FlightStatus
          displayName={carrierDisplayName}
          flightNumber={flightNumber}
          status={flightData?.status}
          divertedAirportDisplayCode={divertedAirportDisplayCode}
        />
      )}
      <BodyCard>
        {flightData ? (
          <>
            <FlightSummary flightData={flightData} />
            <Codeshares
              flightNumber={flightData?.flightNumber}
              operatedBy={flightData?.carrierDetails}
              marketedBy={flightData?.codeshares}
            />
            <EventTimeline
              eventUpdates={flightData?.updates ?? []}
              departureAirportDisplayCode={departureAirportDisplayCode}
              arrivalAirportDisplayCode={arrivalAirportDisplayCode}
              departureTimeZone={flightData?.departureTimeZone}
              arrivalTimeZone={flightData?.arrivalTimeZone}
            />
          </>
        ) : (
          <CenteredText>No Data Available</CenteredText>
        )}
      </BodyCard>
    </>
  );
};